import {
  transformBooleanToStringQaSpecValue,
  transformStringToBooleanQaSpecValue,
} from 'pages/qa-spec/utils/transformQaBooleanValue';

const IGNORE_KEYS = ['contains', 'doesNotContain'];

export const transformQaClaimsToFormValues = (dataQaClaims) => {
  let result = {};

  if (dataQaClaims) {
    for (const [key, value] of Object.entries(dataQaClaims)) {
      result = {
        ...result,
        [key]: IGNORE_KEYS.includes(key)
          ? value
          : transformBooleanToStringQaSpecValue(value),
      };
    }
  }

  return result;
};

export const transformQaClamsToParams = (formValues) => {
  let result = {};

  for (const [key, value] of Object.entries(formValues)) {
    result = {
      ...result,
      [key]: IGNORE_KEYS.includes(key)
        ? value
        : transformStringToBooleanQaSpecValue(value),
    };
  }

  return result;
};
